import { VerifyStageEnum } from './types';

/** 格式化外部链接跳转路由参数 */
export const formatExternalLinkJumpRouterQuery = (query: Record<string, unknown>)
  : Record<string, unknown> => {
  if (query) {
    return {
      ...query,
      needEducation: query.needEducation === 'true',
      needMonthSalary: query.needMonthSalary === 'true',
      needEmergencyContact: query.needEmergencyContact === 'true',
    };
  }

  return {};
};

/**
 * 服务历史接口返回的步骤数 转换成 检验步骤枚举
 * 服务step步骤含义：
 * 0: VerifyStageEnum.USER_BASE
 * 1: VerifyStageEnum.CONTACT_INFO
 * 2: VerifyStageEnum.ID_CARD
 * 3: VerifyStageEnum.BIO_AUTH
 */
export const transformServerStepCountToStageEnumList = (
  stepCount: number,
  forceVerifyIdCard = false,
): VerifyStageEnum[] => {
  const stages = [];
  const shouldStartStepCount = forceVerifyIdCard ? Math.min(stepCount, 2) : stepCount;

  for (let step = shouldStartStepCount; step <= 3; step++) {
    switch (step) {
      case 0:
        stages.push(VerifyStageEnum.USER_BASE);
        break;
      case 1:
        stages.push(VerifyStageEnum.CONTACT_INFO);
        break;
      case 2:
        stages.push(VerifyStageEnum.ID_CARD);
        break;
      case 3:
        stages.push(VerifyStageEnum.BIO_AUTH);
        break;
      default:
        break;
    }
  }

  return stages;
};
